export default __webpack_public_path__ + "static/media/coltDrawerBg.fe50ed9c.JPEG";